module.exports = __webpack_public_path__ + "img/44.bf4d05b6.png";